import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { DestinationService } from '../../_services/_masters/destination.service';
import { Subject } from 'rxjs';
import 'rxjs/add/operator/map';
import { Http, Response } from '@angular/http';
import { environment } from '../../../environments/environment';

import { SelectablesService } from '../../selectables.service';
import { ConsignorService } from '../../_services/_masters/consignor.service';
import { DistrictService } from '../../_services/_masters/district.service';

import swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
// import * as $ from 'jquery';
declare var $ : any;

class DestinationFrom {
	destination_name:string;
	district : string;
	branch: string;
	contact_no: string;
}

@Component({
	selector: 'app-destination',
	templateUrl: './destination.component.html',
	styleUrls: ['./destination.component.css']
})
export class DestinationComponent implements OnInit {

	//stations : string[] = ['LATUR', 'OSMANABAD', 'Admin'];
	//consignors : string[] = ['RCF', 'Other Clients'];
	branch : string[] = [];
	district : string[] = [];
	consignors: any[] = [];
	check_branch: boolean = true;
	selected_branch="";

	destinationForm : FormGroup;
	modalDestinationForm : FormGroup;
	modalData : any;

	// Data Table Configurations
	dtOptions: any = {};
	dataTable: any;
	dtTrigger: Subject<any> = new Subject();
	destination_form: DestinationFrom[] = [];

	currentUser  : any ;
	token : any ;
	user_role : string = null ;
	user_branch : string = null ;

	query : any = null;
	response : any = null;


	url = environment.url
	@ViewChild(DataTableDirective)
	dtElement: DataTableDirective;
	
	constructor( private destinationService : DestinationService,
		private selectConsignorService : ConsignorService,
		private selectDistrictService : DistrictService,
		private selectBranchService : SelectablesService,
	 	private http: Http) { }

	ngOnInit() 
	{
		this.destinationForm = new FormGroup({
			'destination_name': new FormControl(null , Validators.required),
			'district': new FormControl(null , Validators.required),
			'branch': new FormControl(null , Validators.required),
			'consignor': new FormControl(null , Validators.required),
			'kms': new FormControl(null , Validators.required)
		});

		this.modalDestinationForm = new FormGroup({
			'destination_name': new FormControl(null , Validators.required),
			'district': new FormControl(null , Validators.required),
			'branch': new FormControl(null , Validators.required),
			'consignor': new FormControl(null , Validators.required),
			'kms': new FormControl(null , Validators.required)
		});


		this.dtOptions = {
			pagingType: 'full_numbers',
			pageLength: 5,
			responsive: true,
			// select:true,
			rowCallback: (row: Node, data: any[] | Object, index: number) => {
				const self = this;
				// Unbind first in order to avoid any duplicate handler
				// (see https://github.com/l-lin/angular-datatables/issues/87)
				$('td', row).unbind('click');
				$('td', row).bind('click', () => {
					self.someClickHandler(data);
				});
				return row;
			},
			dom: 'Bfrtip',
			// Configure the buttons
			buttons: [
				// 'columnsToggle',
				'colvis',
				'copy',
				'print',
				'excel'
			]
		};


		this.http.get(this.url + '/masters/destination/all')
		.map(this.extractData)
		.subscribe(forms => {
			this.destination_form = forms;
			this.dtTrigger.next();
		});




		var myObject = localStorage.getItem('currentUser');
		var temp = JSON.parse(myObject);	
		if(localStorage.getItem('currentUser'))
		{
			if (temp["role"] === 'Admin')
			{
				this.getBranch();
				this.getConsignorBySelectedBranch(null);
				this.getDistrict();
				this.check_branch = false;
			}
			else if(temp['role'] === 'Manager' || temp['role'] === 'Employee')
			{				
  				this.destinationForm.get('branch').setValue(temp['branch']);
  				this.branch.push(temp['branch']);
				this.getConsignorBySelectedBranch(temp['branch']);
				this.selected_branch=temp['branch'];
				this.getDistrict();
				this.check_branch = true;
			}
		}


	}
	
    getBranch()
    {
     	this.selectBranchService.getBranches()
		.subscribe(
			branches => {
				for(var i=0;i<branches.length;i++)
				{
					this.branch.push(branches[i]['branch_name']);
				}
			});
    }
    getConsignorBySelectedBranch(branch)
    {
    	if(this.check_branch==false)
    		this.selected_branch=branch;

    	this.consignors=[];
    	this.destinationForm.get('consignor').setValue("");
     	this.selectConsignorService.getConsignorFormWithBranch(branch)
		.subscribe(
			consignors => {
				for(var i=0;i<consignors.length;i++)
				{
					this.consignors.push(consignors[i]['consignor_name']);
				}
			});
    }
    getDistrict()
    {
    	this.district=[];
    	this.selectDistrictService.getDistrict()
		.subscribe(
			district => {
				for(var i=0;i<district.length;i++)
				{
					this.district.push(district[i]['district_name']);
				}
			});
    }
    showDestinationTable(client)
    {
     	let table_name = this.selected_branch+"_"+client+"_destination";
		// this.http.get(this.url + '/masters/destination/get/branchandclient/'+table_name)
		// .map(this.extractData)
		// .subscribe(forms => {
		// 	this.destination_form = forms;
		// 	this.dtTrigger.next();
		// });

		this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
			dtInstance.destroy();
			this.http.get(this.url + '/masters/destination/get/branchandclient/'+table_name)
				.map(this.extractData)
				.subscribe(forms => {
				this.destination_form = forms;
				console.log(this.destination_form);
				// Calling the DT trigger to manually render the table
				this.dtTrigger.next();
			});
		});

    }

	
	private extractData(res: Response) {
		const body = res.json();
		console.log(body.data || {});
		return body;

	};

	someClickHandler(info: any): void {
		this.destinationService.getDestinationFormWith(info[1]+"_"+info[3].toString().replace(/&amp;/g, '&').replace(/%20/g, ' ')+"_destination",info[0])
		.subscribe(response => {
			console.log('aaaaa'+JSON.stringify(response))
			this.modalData = JSON.stringify(response)
			this.modalData = JSON.parse(this.modalData)
			this.modalDestinationForm.patchValue({
				"destination_name": this.modalData[0].destination_name,
				'branch': this.modalData[0].branch,
				"district": this.modalData[0].district,
				"kms": this.modalData[0].kms,
				"consignor": this.modalData[0].consignor
			});
		});	
		$("#default-modal").modal('show');
	};

	submit(){
		console.log(this.destinationForm.value);
		//this.destinationService.addNewDestination(this.destinationForm.value)
		//.subscribe(response => console.log(response));

		this.destinationService.addNewDestination(this.destinationForm.value)
		.subscribe(response => 
		{
			
			if(response['status'])
			{
				swal('Save', 'Record save successfully', 'success');
				this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
					dtInstance.destroy();
					this.http.get(this.url + '/masters/destination/all')
						.map(this.extractData)
						.subscribe(forms => {
						this.destination_form = forms;
						console.log(this.destination_form);
						// Calling the DT trigger to manually render the table
						this.dtTrigger.next();
					});
				});
				
			}
			else
			{
				swal('Oops!', 'Something went wrong on the page!', 'error');
			}
		});
	};

	updateDestination(){
		console.log(this.modalDestinationForm.value);
		console.log(this.modalData);

		this.query={
			"destination_oid" : this.modalData[0]._id,
			"destination_data" : this.modalDestinationForm.value
		}

		console.log(this.query);

		this.http.post( this.url + "/masters/destination/update", this.query)
		.subscribe(res => { 
			console.log(res.json());
			this.response = res.json();
			console.log(this.response.status);
			if (this.response.status){

				if (this.response.message === 'Destination Updated Successfully'){
					swal(
						'Success',
						'Destination Form Updated Successfully',
						'success'
					);
					this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => 
					{
						dtInstance.destroy();
						this.http.get(this.url + '/masters/destination/all')
							.map(this.extractData)
							.subscribe(forms => 
							{
								this.destination_form = forms;
								console.log(this.destination_form);
								// Calling the DT trigger to manually render the table
								this.dtTrigger.next();
							});
					});

				}

				if (this.response.message === 'Destination Information not Changed'){
					swal(
						'Info',
						'Destination information not changed',
						'info'
					);
				}
			}
			else{
				swal(
					'Unknown Error',
					'Please Refresh your page',
					'error'
				);
			}
			
		});
	};


	// DELETE CONSIGNOR
	deleteDestination(){
		this.query={
			"destination_id" : this.modalData[0]._id.$oid,
			"branch": this.modalData[0].branch,
			"consignor": this.modalData[0].consignor
		}

		console.log(this.query);

		swal({
			title: 'Are you sure?',
			text: 'You want to delete Godown',
			type: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'No, keep it'
		}).then((result) => {
			if (result.value) {
				this.http.post(this.url + '/masters/destination/delete', this.query)
				.map(response => response.json())
				.subscribe(
					(response)=>{
						console.log(response);
						if (response["status"]){
							console.log(response);
							console.log("success");
							swal('Deleted!','Your Godown has been deleted.','success');

							this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => 
							{
								dtInstance.destroy();
								this.http.get(this.url + '/masters/destination/all')
									.map(this.extractData)
									.subscribe(forms => 
									{
										this.destination_form = forms;
										console.log(this.destination_form);
										// Calling the DT trigger to manually render the table
										this.dtTrigger.next();
									});
							});
							
							$("#default-modal").modal("hide");
							
						}else{
							swal("error","Oops , Somthing went wrong, Godown is not deleted","error");
						}
					},
					(error)=>console.log(error.json())
					);
			} 
		})
	}

}



// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/masters/destination/destination.component.ts